import App from "./App";
import LoginProvider from "./dialogs/Login";
import DialogProvider from "./libs/dialog/DialogProvider";
import SnackbarProvider from "./libs/dialog/SnackbarProvider";
import PathProvider from "./libs/path/PathProvider";
import "./scss/index.scss"
import 'react-perfect-scrollbar/dist/css/styles.css';

import ReactDOM from "react-dom/client";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration"

(() => {
    const root = ReactDOM.createRoot(document.getElementById("root")!)
    root.render(
    <PathProvider><SnackbarProvider><DialogProvider>
        <LoginProvider>
            <App/>
        </LoginProvider>
    </DialogProvider></SnackbarProvider></PathProvider>
    )

    serviceWorkerRegistration.register()

})()